import { createAppSelector } from "./base";
import { OrgCapability, hasOrgCapability, selectCurrentUserOrgRole } from "./permissions";

import { RootState } from "store";

export const selectOnBoardingCourse = (state: RootState, courseId: string) =>
  state.local.onBoardingCourses[courseId];

export const selectIsSidebarOpen = (state: RootState) => state.local.isSidebarOpen;

export const selectIsEditModeEnabled = (state: RootState) => state.local.editMode;

export const selectIsEditingOrgSettings = createAppSelector(
  [selectIsEditModeEnabled, selectCurrentUserOrgRole],
  (isEditModeEnabled, userOrgRole) =>
    isEditModeEnabled && hasOrgCapability(userOrgRole, OrgCapability.CAN_AUTHOR_ORG),
);

export const selectLastHomeRole = (state: RootState) => state.local.lastHomeRole;

export const selectLastCourseViewOption = (state: RootState) => state.local.lastCourseViewOption;

export const selectLocalMicIsEnabled = (state: RootState) => state.local.localAvState?.isMicEnabled;

export const selectLocalCameraIsEnabled = (state: RootState) =>
  state.local.localAvState?.isCameraEnabled;

export const selectPreferredMicDeviceLabel = (state: RootState) =>
  state.local.localAvState?.preferredMicDeviceLabel || null;

export const selectPreferredCameraDeviceLabel = (state: RootState) =>
  state.local.localAvState?.preferredCameraDeviceLabel || null;

export const selectIsBackgroundBlurEnabled = (state: RootState) =>
  state.local.localAvState?.isBackgroundBlurEnabled;

export const selectWasAutoMuted = (state: RootState) => state.local.localAvState?.wasAutoMuted;

export const selectLastAutoMuteScenario = (state: RootState) =>
  state.local.localAvState?.lastAutoMuteScenario;

export const selectClassChatReadAtForCurrentCourse = (state: RootState) => {
  const chatReadAt = state.local.classChatReadAt[state.view.currentCourseId];
  return chatReadAt ? new Date(chatReadAt) : undefined;
};

export const selectApiError = (state: RootState) => state.local.apiError;
